var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55198 3.69515C6.0128 2.43204 7.91709 1.66797 9.99984 1.66797C14.6022 1.66797 18.3332 5.39893 18.3332 10.0013C18.3332 11.7814 17.775 13.4311 16.8242 14.7851L14.1665 10.0013H16.6665C16.6665 6.3194 13.6818 3.33464 9.99984 3.33464C8.20802 3.33464 6.58131 4.04153 5.38336 5.19165L4.55198 3.69515ZM15.4477 16.3075C13.9868 17.5706 12.0826 18.3346 9.99984 18.3346C5.39746 18.3346 1.6665 14.6036 1.6665 10.0013C1.6665 8.22119 2.22466 6.57144 3.1755 5.2175L5.83317 10.0013H3.33317C3.33317 13.6832 6.31794 16.668 9.99984 16.668C11.7917 16.668 13.4183 15.9611 14.6163 14.811L15.4477 16.3075Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshLine);
export default __webpack_public_path__ + "static/media/refresh-line.437bea0613cf20933b9b750ff617792a.svg";
export { ForwardRef as ReactComponent };